import{gql as e}from"@apollo/client";const s=e`
  mutation createUserOriginalPicture($asset: CreateUserAssetInputType!) {
    asset {
      createUserAsset(asset: $asset) {
        asset {
          assetId
          contentType
          fileName
          presignedPutUrl
          presignedUrl
          s3Key
          fileSizeInBytes
          uploaded
        }
        s3Key
        signedUrl
      }
    }
  }
`;export{s as UPDATE_BASE_PROFILE_PICTURE};
//# sourceMappingURL=useUpdateBaseProfilePicture.graphql.js.map
